import { render, staticRenderFns } from "./Database_improve_article.vue?vue&type=template&id=28615598"
import script from "./Database_improve_article.vue?vue&type=script&lang=js"
export * from "./Database_improve_article.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports